import styled from 'styled-components';
import { fonts, spacing } from 'ui/theme';

import {
  useHasMultipleConditions,
  useIsFirstCondition,
  useIsLastCondition,
} from '../../../hooks/form';
import { AddConditionButton, DeleteConditionButton } from '../buttons';
import { ResetConditionButton } from '../buttons/ResetConditionButton';
import { Prompt } from '../Prompt';
import { CombinatorSelect } from '../selects';
import { PropertyForm } from './PropertyForm';

const Wrapper = styled.div<{ $isFirstCondition: boolean; $isAddButtonVisible: boolean }>`
  column-gap: ${spacing.base};
  display: grid;
  flex-direction: row;
  font-family: ${fonts.sansSerif};
  grid-template-columns: ${({ theme }) => `${theme.spacing.values.x3} 1fr min-content`};
  padding: 20px;
  padding-left: ${({ theme }) => theme.spacing.values}
    ${({ $isFirstCondition }) => (!$isFirstCondition ? 'padding-top: 0;' : '')};
`;

const ButtonGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${spacing.base};
`;

export const DATA_TEST = {
  wrapper: 'condition-form-wrapper',
};

export const ConditionForm = () => {
  const isFirstCondition = useIsFirstCondition();
  const isLastCondition = useIsLastCondition();
  const hasMultipleConditions = useHasMultipleConditions();
  const isAddButtonVisible = isLastCondition && hasMultipleConditions;

  return (
    <Wrapper
      $isFirstCondition={isFirstCondition}
      $isAddButtonVisible={isAddButtonVisible}
      data-test={DATA_TEST.wrapper}
    >
      <Prompt />
      <PropertyForm />
      <ButtonGroupWrapper>
        <CombinatorSelect />
        {isAddButtonVisible && <AddConditionButton />}
        <ResetConditionButton />
        <DeleteConditionButton />
      </ButtonGroupWrapper>
    </Wrapper>
  );
};
